import { createDispatchFunction } from 'shared/helpers';
import { partial } from 'lodash';
import StaffService from './StaffService';

// Actions
const GET_TC_EVENT_STAFF = 'staff/GET_TC_EVENT_STAFF';
const GET_TC_EVENT_NON_PERSONNEL_STAFF = 'staff/GET_TC_EVENT_NON_PERSONNEL_STAFF';
const GET_AVAILABLE_TC_STAFF = 'staff/GET_AVAILABLE_TC_STAFF';
const GET_TC_NON_PERSONNEL_STAFF = 'staff/GET_TC_NON_PERSONNEL_STAFF';
const CREATE_TC_NON_PERSONNEL_STAFF = 'staff/CREATE_TC_NON_PERSONNEL_STAFF';
const GET_INVITED_EVENT_STAFF = 'staff/GET_INVITED_EVENT_STAFF';
const ASSIGN_EVENT_STAFF = 'staff/ASSIGN_EVENT_STAFF';
const ASSIGN_EVENT_NON_PERSONNEL_STAFF = 'staff/ASSIGN_EVENT_NON_PERSONNEL_STAFF';
const UNASSIGN_EVENT_NON_PERSONNEL_STAFF = 'staff/UNASSIGN_EVENT_NON_PERSONNEL_STAFF';
const UPDATE_EVENT_STAFF = 'staff/UPDATE_EVENT_STAFF';
const UNASSIGN_EVENT_STAFF = 'staff/UNASSIGN_EVENT_STAFF';
const GET_STAFF_INVITATIONS = 'staff/GET_STAFF_INVITATIONS';
const UPDATE_STAFF_INVITATION = 'staff/UPDATE_STAFF_INVITATION';
const GET_TEST_CENTER_INVITATIONS = 'staff/GET_TEST_CENTER_INVITATIONS';
const UPDATE_TEST_CENTER_INVITATION = 'staff/UPDATE_TEST_CENTER_INVITATION';


const initialState = {
  availableTcStaff: [],
  tcNonPersonnelStaff: [],
  tcEventStaff: [],
  tcEventNonPersonnelStaff: [],
  invitedEventStaff: [],
  staffInvitations: [],
  testCenterInvitations: [],
  error: '',
  loading: '',
};

// Reducer
export default function staffReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TC_EVENT_STAFF:
      if (action.result.loading) {
        return {
          ...state,
          tcEventStaff: action.result.data || state.tcEventStaff || [],
        };
      }
      return {
        ...state,
        tcEventStaff: action.result.data || [],
      };
    case GET_TC_EVENT_NON_PERSONNEL_STAFF:
      return {
        ...state,
        tcEventNonPersonnelStaff: action.result.data || [],
      };
    case CREATE_TC_NON_PERSONNEL_STAFF: {
      if (action.result.loading) {
        return {
          ...state,
          loading: action.result.loading,
          error: '',
        };
      }
      if (action.result.data) {
        const response = action.result.data;
        const formattedResponse = { nonPersonnelId: response.id, ...response };
        return {
          ...state,
          tcNonPersonnelStaff: [...state.tcNonPersonnelStaff, formattedResponse],
          loading: action.result.loading,
        };
      } if (action.result.error) {
        return {
          ...state,
          error: action.result.error,
          loading: action.result.loading,
        };
      }
      return state;
    }
    case ASSIGN_EVENT_NON_PERSONNEL_STAFF: {
      if (action.result.loading) {
        return {
          ...state,
          loading: action.result.loading,
          error: '',
        };
      }
      if (action.result.error) {
        return {
          ...state,
          error: action.result.error,
          loading: action.result.loading,
        };
      }
      if (action.result.data) {
        return {
          ...state,
          tcEventNonPersonnelStaff: (action.result.data && [action.result.data]) || [],
          loading: action.result.loading,
        };
      }
      return state;
    }
    case UNASSIGN_EVENT_NON_PERSONNEL_STAFF: {
      if (action.result.loading) {
        return {
          ...state,
          loading: action.result.loading,
          error: '',
        };
      }
      if (action.result.error) {
        return {
          ...state,
          error: action.result.error,
          loading: action.result.loading,
        };
      }
      if (action.result.data) {
        return {
          ...state,
          tcEventNonPersonnelStaff: [],
          loading: action.result.loading,
        };
      }
      return state;
    }
    case GET_AVAILABLE_TC_STAFF:
      return {
        ...state,
        availableTcStaff: action.result.data || [],
      };
    case GET_TC_NON_PERSONNEL_STAFF:
      return {
        ...state,
        tcNonPersonnelStaff: action.result.data || [],
      };
    case GET_INVITED_EVENT_STAFF:
      return {
        ...state,
        invitedEventStaff: action.result.data || [],
      };

    case GET_STAFF_INVITATIONS:
      return {
        ...state,
        staffInvitations: action.result.data,
      };
    case GET_TEST_CENTER_INVITATIONS:
      return {
        ...state,
        testCenterInvitations: action.result.data,
      };
    case UPDATE_TEST_CENTER_INVITATION:
      return {
        ...state,
        error: action.result.error,
        loading: action.result.loading,
      };
    default:
      return state;
  }
}

// Action Creators
export function getTcEventStaffAction(result) {
  return { type: GET_TC_EVENT_STAFF, result };
}

export function getTcEventNonPersonnelStaffAction(result) {
  return { type: GET_TC_EVENT_NON_PERSONNEL_STAFF, result };
}

export function clearTcEventStaffAction() {
  return { type: GET_TC_EVENT_STAFF, result: { data: [] } };
}

export function clearTcEventNonPersonnelStaffAction() {
  return { type: GET_TC_EVENT_NON_PERSONNEL_STAFF, result: { data: [] } };
}

export function getAvailableTcStaffAction(result) {
  return { type: GET_AVAILABLE_TC_STAFF, result };
}

export function getTcNonPersonnelStaffAction(result) {
  return { type: GET_TC_NON_PERSONNEL_STAFF, result };
}

export function createTcNonPersonnelStaffAction(result) {
  return { type: CREATE_TC_NON_PERSONNEL_STAFF, result };
}

export function getInvitedEventStaffAction(result) {
  return { type: GET_INVITED_EVENT_STAFF, result };
}

export function getStaffInvitationsAction(result) {
  return { type: GET_STAFF_INVITATIONS, result };
}

export function updateStaffInvitationAction(result) {
  return { type: UPDATE_STAFF_INVITATION, result };
}

export function getTestCenterInvitationsAction(result) {
  return { type: GET_TEST_CENTER_INVITATIONS, result };
}

export function updateTestCenterInvitationAction(result) {
  return { type: UPDATE_TEST_CENTER_INVITATION, result };
}

export function updateEventStaffAction(result) {
  return { type: UPDATE_EVENT_STAFF, result };
}

export function assignEventStaffAction(result) {
  return { type: ASSIGN_EVENT_STAFF, result };
}

export function assignEventNonPersonnelStaffAction(result) {
  return { type: ASSIGN_EVENT_NON_PERSONNEL_STAFF, result };
}

export function unAssignEventNonPersonnelStaffAction(result) {
  return { type: UNASSIGN_EVENT_NON_PERSONNEL_STAFF, result };
}

export function unassignEventStaffAction(result) {
  return { type: UNASSIGN_EVENT_STAFF, result };
}

// Action dispatcher functions

export function getTcEventStaff(id) {
  return createDispatchFunction(
    partial(StaffService.getTcEventStaff, id),
    getTcEventStaffAction
  );
}

export function getTcEventNonPersonnelStaff(id) {
  return createDispatchFunction(
    partial(StaffService.getTcEventNonPersonnelStaff, id),
    getTcEventNonPersonnelStaffAction
  );
}

export function getAvailableTcStaff(tcEventId, params) {
  return createDispatchFunction(
    partial(StaffService.getAvailableTcStaff, tcEventId, params),
    getAvailableTcStaffAction
  );
}

export function getTcNonPersonnelStaff(tcId) {
  return createDispatchFunction(
    partial(StaffService.getTcNonPersonnelStaff, tcId),
    getTcNonPersonnelStaffAction
  );
}

export function createTcNonPersonnelStaff(testCenterId, data) {
  return createDispatchFunction(
    partial(StaffService.createTcNonPersonnel, testCenterId, data),
    createTcNonPersonnelStaffAction
  );
}

export function getInvitedEventStaff(eventId) {
  return createDispatchFunction(
    partial(StaffService.getInvitedEventStaff, eventId),
    getInvitedEventStaffAction
  );
}

export function getStaffInvitations() {
  return createDispatchFunction(
    partial(StaffService.getStaffInvitations),
    getStaffInvitationsAction
  );
}

export function updateStaffInvitation(id, status) {
  return createDispatchFunction(
    partial(StaffService.updateStaffInvitation, id, status),
    updateStaffInvitationAction
  );
}

export function getTestCenterInvitations() {
  return createDispatchFunction(
    partial(StaffService.getTestCenterInvitations),
    getTestCenterInvitationsAction
  );
}

export function updateTestCenterInvitation(id, status) {
  return createDispatchFunction(
    partial(StaffService.updateTestCenterInvitation, id, status),
    updateTestCenterInvitationAction
  );
}

export function assignEventStaff(data) {
  return createDispatchFunction(
    partial(StaffService.assignEventStaff, data),
    assignEventStaffAction
  );
}

export function assignEventNonPersonnelStaff(testCenterEventId, nonPersonnelId, role) {
  const payload = {
    testCenterEventId,
    nonPersonnelId,
    role,
  };
  return createDispatchFunction(
    partial(StaffService.assignEventNonPersonnelStaff, payload),
    assignEventNonPersonnelStaffAction
  );
}

export function unAssignEventNonPersonnelStaff(testCenterEventId, nonPersonnelId, role) {
  const payload = {
    testCenterEventId,
    nonPersonnelId,
    role,
  };
  return createDispatchFunction(
    partial(StaffService.unAssignEventNonPersonnelStaff, payload),
    unAssignEventNonPersonnelStaffAction
  );
}

export function updateEventStaff(data) {
  return createDispatchFunction(
    partial(StaffService.updateEventStaff, data),
    updateEventStaffAction
  );
}

export function unassignEventStaff(data) {
  return createDispatchFunction(
    partial(StaffService.unassignEventStaff, data),
    unassignEventStaffAction
  );
}
